import { EntityType } from '@/app/shared/constants/globalConstants';
import type { DocumentItem, SeparatedAssetDocuments } from '../../types';

interface AssetDocumentsProps {
  documents: DocumentItem[];
  renderDocumentForm: (documents: DocumentItem[]) => React.ReactNode;
}

export default function AssetDocuments({ documents, renderDocumentForm }: AssetDocumentsProps): React.ReactNode {
  const separatedAssetDocuments: SeparatedAssetDocuments = {};

  if (documents.length === 0) {
    return null;
  }

  if (documents.length === 1) {
    const lastDocument = documents[documents.length - 1];

    separatedAssetDocuments[lastDocument.entityId] = {
      entityDisplayName: lastDocument.entityDisplayName,
      documents: [],
    };
  } else {
    for (let i = 1; i < documents.length; i += 1) {
      const current = documents[i];
      const previous = documents[i - 1];

      if (current.entityDisplayName || current.entityType === EntityType.ASSET) {
        if (current.entityId !== previous.entityId) {
          separatedAssetDocuments[current.entityId] = {
            entityDisplayName: current.entityDisplayName,
            documents: [],
          };

          separatedAssetDocuments[previous.entityId] = {
            entityDisplayName: previous.entityDisplayName,
            documents: [],
          };
        } else {
          separatedAssetDocuments[current.entityId] = {
            entityDisplayName: current.entityDisplayName,
            documents: [],
          };
        }
      }
    }
  }

  documents.forEach((document) => {
    if (document.relatedAssetId && Object.hasOwn(separatedAssetDocuments, document.relatedAssetId)) {
      separatedAssetDocuments[document.relatedAssetId].documents.push(document);
      return;
    }

    if (Object.hasOwn(separatedAssetDocuments, document.entityId)) {
      separatedAssetDocuments[document.entityId].documents.push(document);
    }
  });

  return (
    <>
      {Object.entries(separatedAssetDocuments).map(([key, value]) => (
        <div key={key}>
          {value.documents.length > 0 ? (
            <div className="document-form__additional-items--header">{value.entityDisplayName}</div>
          ) : null}
          {renderDocumentForm(value.documents)}
        </div>
      ))}
    </>
  );
}
